import {createInfinityClientSignals} from '@pexip/infinity';

import {
    PARTICIPANT_EVENT_BATCHING_SIZE,
    PARTICIPANT_EVENT_BATCHING_TIMEOUT_MS,
} from '../constants';

export const infinityClientSignals = createInfinityClientSignals([], {
    batchScheduleTimeoutMS: PARTICIPANT_EVENT_BATCHING_TIMEOUT_MS,
    batchBufferSize: PARTICIPANT_EVENT_BATCHING_SIZE,
});
